import React, { useRef } from 'react';
import { Box, TextField } from '@mui/material';
import { TextareaQuestion as TextareaQuestionType } from '../../interfaces';
import { useStyles } from './styles';
import { usePreventGameKeydownListening } from '@hooks';

interface TextareaQuestionProps {
  question: TextareaQuestionType;
  selectedValue?: string;
  onSelect: (value: string) => void;
}

const TextareaQuestion: React.FC<TextareaQuestionProps> = ({
  question,
  selectedValue,
  onSelect,
}) => {
  const classes = useStyles();
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const preventKeydownCallback = (event: Event) => {
    if ((event as KeyboardEvent).key !== 'Enter') {
      event.stopPropagation();
    }
  };

  usePreventGameKeydownListening<HTMLTextAreaElement>(
    textareaRef,
    preventKeydownCallback,
  );

  return (
    <Box sx={classes.container}>
      <TextField
        multiline
        rows={8}
        value={selectedValue || ''}
        onChange={(e) => onSelect(e.target.value)}
        placeholder={question.placeholder || 'Type your suggestions here'}
        inputProps={{
          maxLength: question.maxLength || 1000,
          ref: textareaRef,
        }}
        sx={classes.textField}
      />
      {question.maxLength && (
        <Box sx={classes.counterContainer}>
          <Box sx={classes.counterText}>
            {selectedValue?.length || 0}/{question.maxLength}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default TextareaQuestion;
